export enum UploadAutoGeneratedThumbnailErrorCodes {
  UnauthorizedRequest = 0, // Authorization has been denied for this request. Token Validation Failed.
  UniverseDoesNotExist = 3, // The universe does not exist.
  UnauthorizedToConfigureUniverse = 4, // You are not authorized to configure this universe.
  NoRootPlace = 5, // The universe has no root place.
  ThumbnailsAddedTooOften = 6, // Thumbnails of this universe are being added too often.
}

export enum UploadVideoThumbnailErrorCodes {
  UnauthorizedRequest = 0,
  UnauthorizedToConfigureUniverse = 4,
  NotAllowedToAddThumbnails = 16, // You are not allowed to add video thumbnails.
  UniverseDoesNotExist = 3,
  NoRootPlace = 5,
  InvalidURL = 2, // The video URL is invalid.
  EmbeddingNotSupported = 10, // The provided video does not support embedding.
  DurationTooLong = 11, // The video duration is too long.
  DescriptionTooLong = 12, // The video description is too long.
  DescriptionUnacceptable = 13, // This video description is not acceptable.
  VideoUnacceptable = 14, // This video is not acceptable.
  NotEnoughFunds = 15, // You do not have sufficient funds to purchase a video thumbnail.
}

export enum UploadImageThumbnailErrorCodes {
  UnauthorizedRequest = 0, // Authorization has been denied for this request. Token Validation Failed.
  NoPermission = 5, // You do not have permission to manage this item.
  InvalidFormat = 1, // File uploaded does not match known image format. Try converting to png.
  FileNotPresent = 2, // File not present in request.
  TargetItemInvalid = 4, // Target item is invalid or does not exist.
  UploadTooOften = 3, // You're uploading too much, please wait and try again later.
}

export enum ReorderThumbnailErrorCodes {
  UnauthorizedRequest = 0,
  RequestBodyMissing = 1, // The request body is missing.
  NoRootPlace = 5,
  NoThumbnailIds = 7, // The list of thumbnail ids is required.
  TooManyThumbnailIds = 8, // Too many thumbnail ids provided.
  InvalidThumbnailId = 9, // One or more of the provided thumbnail ids are not valid.
  UnauthorizedToConfigureUniverse = 4,
  UniverseDoesNotExist = 3,
}

export enum DeleteThumbnailErrorCodes {
  NoRootPlace = 5,
  UnauthorizedRequest = 0,
  UnauthorizedToConfigureUniverse = 4,
  UniverseDoesNotExist = 3,
}

export enum UpdateAltTextErrorCodes {
  UnauthorizedRequest = 0,
  RequestBodyMissing = 1,
  UniverseDoesNotExist = 3,
  UnauthorizedToConfigureUniverse = 4,
  NoRootPlace = 5,
  InvalidThumbnailId = 9,
  AltTextTooLong = 17,
  FullyModerated = 19,
}
